import { Component, Input } from '@angular/core';
import { SiteAmenityModel } from 'src/app/models/SiteDetails/SiteAmenityModel';

@Component({
	selector: 'app-about-site',
	templateUrl: './about-site.component.html',
	styleUrls: ['./about-site.component.scss']
})
export class AboutSiteComponent {
	@Input() siteName : string;
	@Input() siteDescription : string;
	@Input() patrolDescription : string;
	@Input() siteAmenities : SiteAmenityModel[];
}
